export default [
    {
        path: "/admin/organizational-charts",
        name: "organizational-chart",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/organizational-chart")
    }
];
